/* ==========================================================================
   FlatWine — menu.js
   Menú móvil. Es la única navegación en celular, así que tiene que ser
   accesible de verdad: foco atrapado dentro del panel, Escape cierra,
   y el foco vuelve al botón que lo abrió.
   ========================================================================== */

(function () {
  'use strict';

  /* Si a11y.js no cargó, la trampa no puede quedar en nada: sin ella el foco
     se escapa a la página de detrás del velo. Se avisa y se sigue sin ciclo,
     que es peor pero no invisible. */
  var avisadoSinTrampa = false;
  function atrapar(root, event) {
    if (window.fwFocusTrap) return window.fwFocusTrap.atrapar(root, event);
    /* El filtro por Tab va ANTES del aviso, y el aviso solo sale una vez. Sin
       las dos cosas, escribir en un campo con el panel abierto emitía un error
       por carácter y enterraba el único mensaje que explica el problema. */
    if (event.key !== 'Tab' || avisadoSinTrampa) return false;
    avisadoSinTrampa = true;
    console.error('[a11y] fwFocusTrap no está disponible: el panel no atrapa el foco');
    return false;
  }

  /* El editor de temas reemplaza la sección del encabezado entera. Sin volver
     a inicializar, el cajón nuevo nunca recibía inert —sus ligas volvían a ser
     tabulables detrás de la página— y el botón de menú dejaba de responder.
     La guarda evita enlazar dos veces sobre un nodo que no se reemplazó. */
  var yaIniciados = new WeakSet();

  function init() {
    var drawer = document.querySelector('[data-navdrawer]');
    var openers = document.querySelectorAll('[data-navdrawer-open]');
    /* En móvil el botón de menú es la ÚNICA navegación. Si falta el cajón, el
       botón queda muerto para siempre y antes se salía sin decir nada: nadie
       podía saber por qué. */
    if (!drawer || !openers.length) {
      if (openers.length) console.error('[menu] hay botón de menú pero no está [data-navdrawer]: la navegación móvil queda muerta');
      return;
    }
    if (yaIniciados.has(drawer)) return;
    yaIniciados.add(drawer);

    var closer = drawer.querySelector('[data-navdrawer-close]');
    var lastFocused = null;

    // Arranca cerrado e inerte: sin esto, sus ligas siguen siendo
    // tabulables detrás de la página aunque no se vean.
    drawer.inert = true;

    function open(trigger) {
      lastFocused = trigger;
      drawer.inert = false;
      drawer.classList.add('is-open');
      document.body.classList.add('nav-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });

      // El foco va al botón de cerrar: es el primer control del panel y
      // deja salir de inmediato a quien navega con teclado.
      if (closer) closer.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      drawer.inert = true;
      document.body.classList.remove('nav-open');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      /* cart.js y search.js ya comprobaban isConnected antes de enfocar. Si el
         botón que abrió el menú fue reemplazado, focus() sobre un nodo suelto
         no hace nada y el foco cae en <body>: quien navega con teclado pierde
         su sitio sin aviso. */
      if (lastFocused && lastFocused.isConnected) lastFocused.focus();
      else if (openers.length) openers[0].focus();
    }

    openers.forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', function () { open(button); });
    });

    if (closer) closer.addEventListener('click', close);

    // Navegar cierra el panel: en móvil el destino queda tapado si no.
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('a')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('is-open')) return;

      if (event.key === 'Escape') {
        /* Si hay sugerencias abiertas dentro del cajón, Escape debe cerrarlas
           a ellas primero. Antes cerraba el cajón entero y las dejaba dentro
           marcadas como expandidas, así que al reabrir el menú aparecían
           sugerencias viejas de una consulta que ya no estaba en el campo. */
        var sugerencias = drawer.querySelector('[data-predictive-results]');
        if (sugerencias && !sugerencias.hidden) return;
        close();
        return;
      }

      // Trampa de foco: sin esto, tabular sale al contenido de atrás,
      // que está visualmente tapado pero sigue siendo enfocable.
      atrapar(drawer, event);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

/* ==========================================================================
   Selector de idioma: envía al elegir, sin esperar al botón.
   Vive aquí y no en su propio archivo porque son ocho líneas y el selector
   comparte sitio con la navegación del pie.
   ========================================================================== */
(function () {
  'use strict';
  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest('[data-language-select]');
    if (!select) return;
    var form = select.closest('form');
    if (!form) {
      console.error('[idioma] el selector no está dentro de su formulario; el cambio no se envía');
      return;
    }
    /* La bandera de al lado se cambia ya, antes de que el servidor conteste:
       recargar con el idioma nuevo tarda, y ver la bandera vieja mientras
       tanto se lee como que el clic no funcionó. */
    var bandera = form.querySelector('[data-language-flag]');
    var opcion = select.options[select.selectedIndex];
    if (bandera && opcion && opcion.dataset.flag) bandera.textContent = opcion.dataset.flag;
    form.submit();
  });
})();
